import { IS_MOBILE_LOGIN, IS_USER_LOGIN, ORIGINAL_URL, USER_INFO_KEY, YJ_ACCESS_TOKEN, LINE_CHANNEL_ID, LINE_REDIRECT_URI, LINE_LOGIN_URI, LINE_LOGIN_CLIENT_ID } from '../configuration';

export const AUTH_FORCE_LOGOUT_EVENT = 'yongjing:force-logout';

export type ForceLogoutReason = 'TOKEN_EXPIRED' | 'TOKEN_MISSING' | 'UNAUTHORIZED' | 'USER_ACTION';

export interface ForceLogoutEventDetail {
  reason: ForceLogoutReason;
  message: string;
  triggeredAt: number;
  state?: string;
}

const DEFAULT_FORCE_LOGOUT_MESSAGE = '\u767b\u5165\u903e\u6642\uff0c\u8acb\u91cd\u65b0\u767b\u5165\u3002';

let hasTriggeredForceLogout = false;

const isBrowser = (): boolean => typeof window !== 'undefined';

export const clearStoredAuth = (): void => {
  if (!isBrowser()) {
    return;
  }

  try {
    const storage = window.localStorage;
    storage.removeItem(USER_INFO_KEY);
    storage.removeItem(YJ_ACCESS_TOKEN);
    storage.removeItem(IS_MOBILE_LOGIN);
    storage.removeItem(IS_USER_LOGIN);
  } catch {
    // ignore storage errors
  }
};

const getClientId = (): string => LINE_LOGIN_CLIENT_ID || LINE_CHANNEL_ID;

export const buildLineLoginUrl = (state = 'STATE'): string => {
  const redirect = encodeURIComponent(LINE_REDIRECT_URI);
  const clientId = getClientId();
  const scope = encodeURIComponent('openid profile email');

  return `${LINE_LOGIN_URI}?response_type=code&client_id=${clientId}&redirect_uri=${redirect}&state=${encodeURIComponent(
    state,
  )}&scope=${scope}`;
};

export const redirectToLineLogin = (state?: string): void => {
  if (!isBrowser()) {
    return;
  }

  const url = buildLineLoginUrl(state);
  window.location.href = url;
};

export const forceLogout = (options?: Partial<ForceLogoutEventDetail>): void => {
  if (!isBrowser()) {
    return;
  }

  if (hasTriggeredForceLogout) {
    return;
  }

  hasTriggeredForceLogout = true;

  const detail: ForceLogoutEventDetail = {
    reason: options?.reason ?? 'TOKEN_EXPIRED',
    message: options?.message ?? DEFAULT_FORCE_LOGOUT_MESSAGE,
    state: options?.state,
    triggeredAt: Date.now(),
  };

  clearStoredAuth();

  try {
    const currentPath = `${window.location.pathname}${window.location.search || ''}`;
    if (currentPath) {
      window.localStorage.setItem(ORIGINAL_URL, currentPath);
    }
  } catch {
    // ignore path storage errors
  }

  window.dispatchEvent(new CustomEvent<ForceLogoutEventDetail>(AUTH_FORCE_LOGOUT_EVENT, { detail }));
};

export const resetForceLogoutStateForTests = (): void => {
  hasTriggeredForceLogout = false;
};
